import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

// HttpOnly cookies (set by backend) are sent automatically via withCredentials.
// No client-readable token storage = no XSS exfiltration surface.
const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;
